<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Detail Invoice</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Invoice <strong>{{ data.no_faktur }}</strong><br />
                    No. Ref <strong>{{ data.no_ref }}</strong><br />
                    Pengiriman ke <strong>{{ data.return_to }}</strong><br />
                    Pengiriman dari <strong>{{ data.office }}</strong><br />
                    Ditransaksikan oleh <strong>{{ data.confirmed_by }}</strong> pada {{ $helper.parseDate(data.confirmed_at) }}, {{ $helper.parseHourMinute(data.confirmed_at) }}<br />
                    Tanggal Pembatalan: <strong>{{ $helper.parseDate(data.cancel_at) }}</strong><br />
                    Divisi: <strong>{{ data.division }}</strong><br />
                    Total Item: <strong>{{ data.total_item }}</strong><br />                    
                    Catatan Invoice: {{ data.note || "-" }}
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="dark" @click="$bvModal.show('m-pin')">
                        <i class="fa fa-print mr-2" />Cetak Invoice
                    </b-button>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Pencarian No. Faktur / IMEI SN">
                        <b-form-input v-model="filterInput" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.return_items"
                :fields="fields"
                :filter="filterInput"
                :filter-included-fields="['no_faktur_pgi', 'imei_sn']"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Invoice kosong.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}
                    </div>
                </template>
                <template v-slot:cell(inventory)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(created)="row">
                    {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                    <div class="small text-muted">
                        {{ row.item.request_note }}
                    </div>
                </template>
                <template v-slot:cell(process)="row">
                    <div v-if="row.item.processed_at != null">
                        {{ $helper.parseDate(row.item.processed_at) }}, {{ $helper.parseHourMinute(row.item.processed_at) }}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template v-slot:cell(cancel)="row">
                    {{ $helper.parseDate(row.item.cancel_at) }}, {{ $helper.parseHourMinute(row.item.cancel_at) }}
                    <div class="small text-muted">
                        {{ row.item.cancel_note }}
                    </div>
                </template>
            </b-table>
        </b-card>
        <b-modal id="m-reprint-invoice" title="Cetak Ulang Invoice" centered hide-footer>
            Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-reprint-invoice')">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-pin" title="PIN Otorisasi" centered hide-footer>
            <b-form-group label="Masukan PIN">
                <b-input type="password" v-model="pin" maxlength="10" @keydown.enter="checkPIN" autofocus />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="checkPIN">
                    Otorisasi
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            filterInput: "",
            returResult: {},
            pin: "",

            data: {
                items: []
            },

            fields: [
                { key: "noFaktur", label: "No. Faktur / IMEI", sortable: true },
                { key: "inventory", label: "Barang", sortable: true },
                { key: "created", label: "Tgl. Request", sortable: true },
                { key: "process", label: "Tgl. Proses", sortable: true },
                { key: "cancel", label: "Tgl. Batal", sortable: true },
            ],
            
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            Promise.all([getData]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },
        
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("inventory-return-cancel-pgi/detail/" + this.$route.params.id + param).then(res => {

                let data = res.data.data

                this.data = data

            })
            .catch(error => this.$helper.parseError(this, error))
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return `${this.$BASE_PRINT_FILE_PATH}/umgtrtpcce/${this.$route.params.id}-${this.data.timestamp}-${this.data.timestamp2}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}/umgtrtpca4/${this.$route.params.id}-${this.data.timestamp}-${this.data.timestamp2}`
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

        checkPIN() {

            if(this.pin == "") return this.$helper.toastError(this, "PIN kosong!")

            let payload = {
                pin: this.pin
            }

            this.isSubmitting = true
            this.$axios.post("invoice/check-pin", payload).then(_ => {

                this.pin = ""
                this.$bvModal.hide("m-pin")
                this.$bvModal.show("m-reprint-invoice")                

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getStatusBadge(status) {
            switch(status) {
                case 0: return ["warning", "PENDING"]
                case 1: return ["primary", "PENGIRIMAN"]
                case 2: return ["success", "TIBA DI PGI"]
                case 9: return ["danger", "DITOLAK"]
                default: return ["light", "-"]
            }
        },

        getReturnReasonString(returnReason) {
            switch(returnReason) {
                case 0: return "Tidak Ada"
                case 1: return "Inventaris PGI"
                case 2: return "Pergantian Barang"
                case 3: return "Prive Pak Andrew"
                case 4: return "Barang Tebusan"
                case 5: return "ICloud/Account"
            }
        }

    },
    created() {
        this.init()
    }
}
</script>

<style>

</style>
